import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import { Add} from '@mui/icons-material';
import { Popper, Grow, Paper, ClickAwayListener, MenuList, IconButton } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useCompanyData } from '../contexts/DataContext';
import CustomizedMenus from'./ServiceListMenu';
import DropdownMenuItem from './DropdownMenuItem';
import { MyLink } from './Navbar';

const useStyles = makeStyles({
    menuList:{
        padding:'0px'
    },

    menuItem:{
        padding: '8px 11px',
        width: 'auto',
        color: '#000',
        height: '100%',
        cursor:'pointer'
    }
});

export default function MoreMenu(props) {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const { data } = useCompanyData();
  const { defaultColor, activeColor, menuFontColor, menuActiveFontColor, isMobile, index, _menuList } = props;
  const classes = useStyles({menuActiveFontColor,activeColor});
  const {id: pathId} = useParams();
  const { companyDomain, isRTL } = data || {};

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const closeMenu = () =>{
    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === 'Escape') {
      setOpen(false);
    }
  }

  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

    const renderMenuItem = (menuItem) => {
        const { englishName, arabicName, visible, externalLink, path, subMenu=[], id } = menuItem;
        const menuExist = subMenu ? subMenu?.filter(v => v?.visible) : false;
        if (!visible) return null; // Return early if not visible
      
        const title = isRTL === 'ar' ? arabicName : englishName;
        const linkPath = path ? companyDomain ? `/temp/${path}` : `/${pathId}/temp/${path}` : '';
    
        if(id === 'service-1') {
          return(
            <CustomizedMenus  {...props} menuActiveFontColor={menuActiveFontColor} menuFontColor={menuFontColor} callback={closeMenu} />
          )
        };
      
        if (menuExist?.length) {
          return (
            <DropdownMenuItem
                title={title}
                externalLink={externalLink}
                to={linkPath}
                menuFontColor={menuFontColor}
                menuActiveFontColor={menuActiveFontColor}
                subMenu={menuExist}
                callback={closeMenu}
                {...props}
            />
          );
        };
      
        return (
          <MyLink
            externalLink={externalLink}
            to={linkPath}
            menuFontColor={menuFontColor}
            menuActiveFontColor={menuActiveFontColor}
            callback={closeMenu}
            moreMenu={true}
            {...props}
          >
            {title}
          </MyLink>
        );
    };

  return (
    <Box 
        mr={isMobile ? 0 : '10px'}
        whiteSpace="nowrap"
        id={`menu-item-${index}`}
        alignSelf='center'
    >
        <IconButton
            ref={anchorRef}
            id="composition-button"
            aria-controls={open ? 'composition-menu' : undefined}
            aria-expanded={open ? 'true' : undefined}
            aria-haspopup="true"
            onClick={handleToggle}
        >
            <Add style={{color:menuFontColor || defaultColor}}/>
        </IconButton>
        <Popper 
            open={open}
            anchorEl={anchorRef.current}
            role={undefined}
            placement="bottom-start"
            transition
            disablePortal
            style={{ zIndex: 1500 }}
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                    <MenuList
                        classes={{root:classes.menuList}}
                        autoFocusItem={open}
                        id="composition-menu"
                        aria-labelledby="composition-button"
                        onKeyDown={handleListKeyDown}
                    >
                  {React.Children.toArray(_menuList.map(renderMenuItem))}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
    </Box>
  );
}